<a [routerLink]="url">
  <img [src]="imageUrl" />
  <div class="mt-4 d-flex justify-content-center justify-content-sm-between">
    <h6>{{ title }}</h6>
    <fa-icon class="ms-4 ms-sm-0 me-2" [icon]="['far', 'chevron-right']"></fa-icon>
  </div>
</a>
